import React, { Suspense, useEffect, useState } from "react";
import { Route, Routes, useSearchParams } from "react-router-dom";
import { routesSchema } from "../config/routesConfig";
import Navbar from "./Navbar";
import AuthProvider from "../components/auth/AuthProvider";
import { activatePremission } from "../notification/firebase";
import HelpCenter from "../pages/help center/HelpCenter";
import { useDispatch, useSelector } from "react-redux";
import { UserSliceType } from "../lib/redux/slices/userSlice";
import { closeSideBar, openSideBar } from "../lib/redux/slices/controlSlice";
import { useViewport } from "../hooks/useViewport";
import { cn } from "../utils/utils";
import MobileNavbar from './MobileNavbar';
import { MOBILE_VIEW_ENDPOINT } from "../constants";
import Breadcrumb from "../components/global/Breadcrumb";

type Props = {};

function Feed({}: Props) {
  //@ts-ignore
  const currentPremision = useSelector(
    //@ts-ignore
    (state: UserSliceType) => state.user.currentPremission
  );
    const [isSmallView,setIsSmallView]=useState(false)
  const [openHelpCenter, setOpenHelpCenter] = React.useState(false);
   const {isMobile,isDesktop,isTablet,sizeInfo} = useViewport()
  const status = useSelector((state: UserSliceType) => state.user.status);
  const stage = useSelector((state: any) => state.user.stage);
  useEffect(() => {
    activatePremission();
  }, []);

    useEffect(()=>{
          if(sizeInfo.currentWidth <MOBILE_VIEW_ENDPOINT ){
             
              setIsSmallView(true)
          }else{
            setIsSmallView(false)
            
          }
    },[sizeInfo.currentWidth,isMobile])
   const {isLandscapeOrientation} = useViewport()
  return (
    <div className={cn("flex flex-col bg-[#F7F8F9] dark:bg-primary w-full py-4 px-2 lg:px-4  overflow-hidden max-h-dvh",'mobile:pt-0')}>
      {!isSmallView ?<Navbar
        openHelpCenter={openHelpCenter}
        setOpenHelpCenter={setOpenHelpCenter}
      />:<MobileNavbar/>}
      <div className="lg:px-4 py-2 ">
       <Breadcrumb/>
        <div className={cn(" h-full  rounded-2xl custom-shadow",isLandscapeOrientation() &&isMobile && 'overflow-auto mobile:pb-[120px]')}>
        <AuthProvider>
          <Suspense
            fallback={
              <div className="loading_auth">
                <span className="loader_auth"></span>
              </div>
            }
          >
            <Routes>
              {routesSchema().map((route) => {
                if (route.tag && currentPremision) {
                 // console.log(route);
                  // if stage approved navigate to home
                  // if status active navigate to home
                  const isActive = status === "Active" ;
                  const isApproved = stage === 'approved'

                  const isAllowed = currentPremision.find(
                    //@ts-ignore
                    (item) => item.section === route.tag
                  )?.read;
                 
                 
                  
                  // const OrgRules = currentPremision?.find(
                  //   //@ts-ignore
                  //   (role) => role?.section.toLowerCase() === "organization"
                  // );

                  const HomeRules = currentPremision?.find(
                    //@ts-ignore
                    (role) => (role?.section === "Home" ||role?.section === "home")
                  );
                  
                  if (!isAllowed ) {
                      
                    if (route.tag === "Organization") {
                      if (status === "Active" ) {
                  
                        
                        return;
                      }
                    } else if (route.tag !== "Home") {
                      return;
                    }
                  }
                  if((status !== 'Active' && stage !== 'approved')&& route.tag === 'Home' && !isAllowed){
                              
                               
                           return
                  } 
                  // if (OrgRules && !OrgRules?.read) {
                  //   return;
                  // }
                }
                return (
                  <Route
                    key={route.title}
                    path={route.path}
                    element={route.element}

                  />
                );
              })}
            </Routes>
          </Suspense>
          <HelpCenter
            openHelpCenter={openHelpCenter}
            setOpenHelpCenter={setOpenHelpCenter}
          />
        </AuthProvider>
      </div>
      </div>
      
    </div>
  );
}

export default Feed;
